import { Component, Input, Output, ChangeDetectionStrategy, EventEmitter } from '@angular/core';

/**
 * Generated class for the ComparisonComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'comparison',
  templateUrl: 'comparison.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComparisonComponent {
  @Input() companies: any = [];
  @Input() chart: string = 'ebitMargin';
  @Output() goToCompany: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  ngOnChanges() {
    if(this.companies) {
      return;
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/comparison/comparison.ts